/*=========================================================================================
  File Name: discountCodes.js
  Description: Hard coded discount codes
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

const discountCodes = [
    { code: '688609', percent: 99 }
];

function findDiscountCode(input) {
    if (!input) {
        return null;
    }
    let normalized = String(input).trim().toUpperCase();
    let match = discountCodes.find(c => { return c.code === normalized });
    return match ? { code: match.code, percent: match.percent } : null;
}

export default {
    discountCodes,
    findDiscountCode
}
